document.addEventListener("DOMContentLoaded", function () {
    const ulElement = document.querySelector(".breadcrumb");

    if (ulElement.offsetWidth > 800) {
        const items = Array.from(ulElement.querySelectorAll("li > a, li > span"));
        let totalWidth = 0;
        let elementsToHighlight = [];

        items.forEach(item => {
            const itemWidth = item.offsetWidth;
            totalWidth += itemWidth;

            if (totalWidth > 800) {
                elementsToHighlight.push(item);
            }
        });

        elementsToHighlight.forEach(item => {
            item.classList.add("prc-breadcrumb-text-elipsis");
        });
    }
    
});